import Siema from 'siema';
import MicroModal from 'micromodal';

function main() {
  const dots = document.querySelectorAll('.pagination-dot');

  const bgSlider = new Siema({
    selector: '.home-img-slider',
    duration: 600,
    easing: 'cubic-bezier(0.77, 0, 0.175, 1)',
    perPage: 1,
    startIndex: 0,
    draggable: false,
    threshold: 20,
    loop: true,
    rtl: false,
    onInit: () => {},
    onChange: () => {}
  });

  const detailsSlider = new Siema({
    selector: '.home-details-slider',
    duration: 600,
    easing: 'cubic-bezier(0.77, 0, 0.175, 1)',
    perPage: 1,
    startIndex: 0,
    draggable: false,
    threshold: 20,
    loop: true,
    rtl: false,
    onInit: () => {}
    // onChange: () => {
    //   dots.forEach(d => d.classList.remove('is-active'));
    //   dots[bgSlider.currentSlide].classList.add('is-active');
    // }
  });

  document.querySelector('.home-right-btn').addEventListener('click', () => {
    bgSlider.next();

    setTimeout(() => detailsSlider.next(), 75);
  });

  document.querySelector('.home-left-btn').addEventListener('click', () => {
    bgSlider.prev();

    setTimeout(() => detailsSlider.prev(), 75);
  });

  // dots.forEach((dot, index) => {
  //   dot.addEventListener('click', () => {
  //     bgSlider.goTo(index);
  //     detailsSlider.goTo(index);
  //   })
  // })

  const getModal = document.querySelector('#notice-modal')
  if (getModal) {
    MicroModal.init();
    MicroModal.show('notice-modal'); 
  }
}

export default main;
